import { render, staticRenderFns } from "./BookingDetailView.vue?vue&type=template&id=75e47980"
import script from "./BookingDetailView.vue?vue&type=script&lang=js"
export * from "./BookingDetailView.vue?vue&type=script&lang=js"
import style0 from "./BookingDetailView.vue?vue&type=style&index=0&id=75e47980&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports